import { Factory } from "views/delivery-board/types/factory.type";

// These are hardcoded values received from Business / Cargill to be used for Factories in the Delivery Board.
export const Factories: Factory[] = [
  {
    factoryName: 'Florø',
    sapCode: '1FBS',
    factoryLocation: {
      latitude: 61.584433,
      longitude: 5.000845,
    },
  },
  {
    factoryName: 'Bergneset',
    sapCode: '1FBT',
    factoryLocation: {
      latitude: 69.238084,
      longitude: 19.361386,
    },
  },
  {
    factoryName: 'Halsa',
    sapCode: '1FBU',
    factoryLocation: {
      latitude: 66.744918,
      longitude: 13.497391,
    },
  },
  {
    factoryName: 'Westfield',
    sapCode: '1FXN',
    factoryLocation: {
      latitude: 55.9322,
      longitude: -3.68849,
    },
  },
  {
    factoryName: 'Kristiansund',
    sapCode: '2IRO',
    factoryLocation: {
      latitude: 63.12079,
      longitude: 7.76052,
    },
  },
  {
    factoryName: 'Gangstøvika',
    sapCode: '2IRP',
    factoryLocation: {
      latitude: 62.47804,
      longitude: 6.22696,
    },
  },
  {
    factoryName: 'Namsos',
    sapCode: '2IRQ',
    factoryLocation: {
      latitude: 64.46429,
      longitude: 11.49607,
    },
  },
  {
    factoryName: 'Finnsnes',
    sapCode: '2IRS',
    factoryLocation: {
      latitude: 69.22851,
      longitude: 17.97054,
    },
  },
  {
    factoryName: 'Brennmoen',
    sapCode: '2IRV',
    factoryLocation: {
      latitude: 69.207608,
      longitude: 19.288987,
    },
  },
  {
    factoryName: 'Husøy',
    sapCode: '2IRY',
    factoryLocation: {
      latitude: 59.33907,
      longitude: 5.30589,
    },
  },
  {
    factoryName: 'Tromsø',
    sapCode: '2MDO',
    factoryLocation: {
      latitude: 69.68066,
      longitude: 18.99572,
    },
  },
  {
    factoryName: 'Harstad',
    sapCode: '2MLB',
    factoryLocation: {
      latitude: 68.57621,
      longitude: 16.52434,
    },
  },
  {
    factoryName: 'Høgset',
    sapCode: '2MLC',
    factoryLocation: {
      latitude: 62.96937,
      longitude: 7.7327,
    },
  },
];
